// extracted by mini-css-extract-plugin
export default {"titles":"style_titles__OQI1h","title":"style_title__HbGgt","wrapper":"style_wrapper__rHC0N"};